import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const websocketHost = process.env.MIX_PUSHER_APP_HOST || window.location.hostname;
const websocketPort = Number(process.env.MIX_PUSHER_APP_PORT || 6001);
const websocketScheme = process.env.MIX_PUSHER_APP_SCHEME || 'http';
const websocketCluster = process.env.MIX_PUSHER_APP_CLUSTER || 'mt1';
const forceTLS = websocketScheme === 'https';

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: websocketCluster,
    wsHost: websocketHost,
    wsPort: websocketPort,
    wssPort: websocketPort,
    forceTLS: forceTLS,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authEndpoint: '/broadcasting/auth',
    auth: {
        headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
            Accept: 'application/json',
        },
    },
});
